export default __webpack_public_path__ + "430c402543e518aed3314683c1a70559.woff";